import AuctionNearby from './components/AuctionNearby';
import AuctionSameAddress from './components/AuctionSameAddress';
import PublicSaleNearby from './components/PublicSaleNearby';
import { useEffect, useState } from 'react';
import axios from 'axios';

interface AuctionProps {
  caseResult?: any;
  filter?: any;
  isPremium?: boolean;
}

interface AuctionData {
  same: any[];
  auction: any[];
  pAuction: any[];
}

const periodLabelMap: Record<string, string> = {
  '3': '3개월 이내',
  '12': '1년 이내',
  '36': '3년 이내',
  '60': '5년 이내',
  '120': '10년 이내',
};

const rangeLabelMap: Record<string, string> = {
  '500': '주변 500m',
  '1000': '주변 1km',
  '3000': '주변 3km',
};

const Auction = ({ caseResult, filter, isPremium = false }: AuctionProps) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AuctionData>({
    same: [],
    auction: [],
    pAuction: [],
  });

  const apiHost = process.env.REACT_APP_HOST_API;

  const baseSelectionOptions = [
    caseResult?.address,
    caseResult?.name,
    periodLabelMap[filter?.period],
  ];

  const selectionOptionsWithRange = [
    ...baseSelectionOptions,
    rangeLabelMap[filter?.range],
  ];

  useEffect(() => {
    if (!caseResult) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const parts = filter.special.split(',');
        const type = parts[0];
        const items = parts.slice(1);

        const commonParams = {
          address: caseResult.address,
          category: caseResult.name,
          mon: Number(filter?.period) || 12,
          limit: Number(filter?.count) || 5,
          distance: Number(filter?.range) || 1000,
        };

        if (type === 'all') {
          const params = { ...commonParams, specialItems: items.join(',') };

          const response = await axios.get(`${apiHost}stat/bid-case`, {
            params,
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          });

          if (response.data?.status === 'success') {
            setData(response.data.data);
          } else {
            setData({ same: [], auction: [], pAuction: [] });
          }
        } else if (type === 'any') {
          const results: any = { same: [], auction: [], pAuction: [] };

          for (const item of items) {
            const params = { ...commonParams, specialItems: item };

            const response = await axios.get(`${apiHost}stat/bid-case`, {
              params,
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
            });

            if (response.data?.status === 'success') {
              results.same.push(...response.data.data.same);
              results.auction.push(...response.data.data.auction);
              results.pAuction.push(...response.data.data.pAuction);
            }
          }

          setData(results);
        } else if (type === 'none' || !type) {
          const params = { ...commonParams, specialItems: '' };

          const response = await axios.get(`${apiHost}stat/bid-case`, {
            params,
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          });
          if (response.data?.status === 'success') {
            setData(response.data.data);
          } else {
            setData({ same: [], auction: [], pAuction: [] });
          }
        }
      } catch (error) {
        console.error('낙찰 사례 조회 실패', error);
        setData({ same: [], auction: [], pAuction: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [caseResult, filter]);

  return (
    <>
      {/* 동일 주소 낙찰 사례 */}
      <AuctionSameAddress
        data={data.same}
        selectionOptions={baseSelectionOptions}
        loading={loading}
        isPremium={isPremium}
      />

      {/* 인근 낙찰 사례 */}
      <AuctionNearby
        data={data.auction}
        selectionOptions={selectionOptionsWithRange}
        loading={loading}
        isPremium={isPremium}
      />

      {/* 인근 공매 사례 */}
      <PublicSaleNearby
        data={data.pAuction}
        selectionOptions={selectionOptionsWithRange}
        loading={loading}
        isPremium={isPremium}
      />
    </>
  );
};

export default Auction;
